import React from 'react';
const NotFoundPage: React.FC = () => <div>404 Not Found</div>;
export default NotFoundPage;